import script from "./ContributorActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./ContributorActivity.vue?vue&type=script&setup=true&lang=js"

import "./ContributorActivity.vue?vue&type=style&index=0&id=7b5cae8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b5cae8e"]])

export default __exports__